import { useTenant } from '../../../context/tenantContext';
import TenantLink from '../../../components/links/tenantLink';
import {
  Box,
  Grid,
  Button,
  Typography,
  Paper,
  styled,
  TextField,
  
} from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily, 
  padding: theme.spacing(2),
  textAlign: 'left',
  // color: theme.palette.primary.main,
  maxWidth: '100%',
  backgroundColor: 'transparent',
  border: 'none',
  boxShadow: 'none',
  minHeight: '450px',
  height: '450px',
  display: 'flex',           
  flexDirection: 'column', 
  justifyContent: 'flex-end',
}));

export default function HeroSection() {
  const { tenant } = useTenant();

  return (
    <Box sx={{ backgroundColor: '#ffe8b2', py: { xs: 4, md: 4 }, width: '100%'}}>
      <Grid container spacing={2} sx={{ maxWidth: 'lg', mx: 'auto', px: 2}}>
        <Grid backgroundColor={false} size={{ xs: 12, md: 8 }} >
          <Item>
            <Typography variant="h4" sx={{ fontWeight: 'bold' }} gutterBottom>
              Plan your Birthday Party at McDonald's
            </Typography>
            <Typography variant="body1" gutterBottom>
              Hassle-free planning, endless smiles. We'll guide you through simple steps to their dream birthday!
            </Typography>
            <Grid container sx={{ my: 2 }} spacing={1}>
              <Grid size={{ xs: 12, md:4 }}>
                <TextField fullWidth label="Where?" variant="outlined" />
              </Grid>
              <Grid size={{ xs: 12, md:4 }}>
                <TextField fullWidth label="When?" variant="outlined" />
              </Grid>
              <Grid size={{ xs: 12, md:4 }}>
                <TenantLink to="/booking" tenant={tenant}>
                  <Button fullWidth className="btn-primary" >
                      Book a Party Now
                  </Button>
                </TenantLink>
              </Grid>
            </Grid>
            
          </Item>
        </Grid>
        {/* <Grid item size="grow">
          <Item>
            <Typography></Typography>
          </Item>
        </Grid> */}
        <Typography className="text-small" gutterBottom px={2}>
          Party packages need a minimum of <b>30 guests</b> | A <b>Php 3,000 down payment</b> is required to secure booking at selected venue
        </Typography>
      </Grid>
    </Box>
  );
}
